import { createContext } from "react";

export const AdPlanContext = createContext({
  parentPlan: {},
  childPlan: {},
});
